import { FC, useCallback, useState } from 'react';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Alert, Box, FormControlLabel, Modal, Stack, Switch } from '@mui/material';
import { RegionEnum } from '~/api/types';
import { ModalHeader } from '~/components';
import { switchBlockStyles } from '~/components/DeleteConfirmationModal/styles';
import { modalActionBlockStyles, modalSmallContainerStyle } from '~/components/styles';
import { useRegion } from '~/hooks';
import { useAppDispatch } from '~/redux';
import { closeModalById } from '~/redux/slices/modalSlice';

export interface ChangeRegionModalProps {
  payload: {
    id: string;
    onSubmit: () => void;
    newRegion: RegionEnum;
  };
}

const ChangeRegionModal: FC<ChangeRegionModalProps> = ({ payload: { id, onSubmit, newRegion } }) => {
  const dispatch = useAppDispatch();
  const [confirmed, setConfirmed] = useState<boolean>(false);
  const region = useRegion();

  const handleClose = useCallback(() => {
    setConfirmed(false);
    dispatch(closeModalById(id));
  }, [dispatch, id]);

  const handleSubmit = () => {
    onSubmit();
    handleClose();
  };

  return (
    <Modal open onClose={handleClose}>
      <Box sx={modalSmallContainerStyle}>
        <ModalHeader onClose={handleClose} title={['Set default region']} />
        <Stack pt={1} pb={3} px={3} spacing={2}>
          <Alert severity="info">
            Your current region is {region.toUpperCase()}. To view different regional data, please confirm you want to
            change your region to {newRegion.toUpperCase()}.
          </Alert>
          <FormControlLabel
            labelPlacement="end"
            label={`I confirm that I want to switch to the ${newRegion.toUpperCase()} region`}
            sx={switchBlockStyles}
            control={
              <Switch
                onClick={(e) => e.stopPropagation()}
                onChange={() => setConfirmed(!confirmed)}
                sx={{ mx: '1rem' }}
              />
            }
          />
        </Stack>
        <Box sx={modalActionBlockStyles}>
          <CustomButton buttonType="borderless" label="Close" onClick={handleClose} />
          <CustomButton label="Confirm" disabled={!confirmed} onClick={handleSubmit} />
        </Box>
      </Box>
    </Modal>
  );
};

export default ChangeRegionModal;
